import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockResetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock_reset"}/>
}
